import _ from 'lodash';
import {
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  
  AUTH_REGISTER_SUCCESS,
  AUTH_REGISTER_FAILURE,
  AUTH_REGISTER_REQUEST,

  AUTH_RESET_REQUEST,
  AUTH_RESET_SUCCESS,
  AUTH_RESET_FAILURE,

  AUTH_SIGNOUT_SUCCESS,
  AUTH_SIGNOUT_FAILURE,
  AUTH_AUTHORIZED,
  AUTH_CONNECTED_USER,
  AUTH_CONNECTED_ACCOUNT,
} from './types';

export default function(state = {}, action) {
  switch (action.type) {
    case AUTH_CONNECTED_USER:
      return { ...state, ready: true, user: {...action.payload.info, ...action.payload.activation} };
    case AUTH_CONNECTED_ACCOUNT:
      return { ...state, ready: true, account: action.payload };
    case AUTH_AUTHORIZED:
        var s = {  }
      if (action.payload)
      {
        s.fbuser = {uid: action.payload.uid, email: action.payload.email } ;
      }
      else
      {
        return { ...state, ready: true };
      }
      return { ...state,  ...s};
      case AUTH_LOGIN_REQUEST:
      return { ...state, waiting: true };
    case AUTH_LOGIN_SUCCESS:
      return { ...state, waiting: false, fbuser: {uid: action.payload.uid, email: action.payload.email }  };
    case AUTH_LOGIN_FAILURE:
      return { ...state, waiting: false, error: {time: new Date().getTime(), ...action.payload}  };

      case AUTH_REGISTER_REQUEST:
      return { ...state, waiting: true };
    case AUTH_REGISTER_SUCCESS:
      return { ...state, waiting: false, fbuser: {uid: action.payload.uid, email: action.payload.email }  };
    case AUTH_REGISTER_FAILURE:
      return { ...state, waiting: false, error: {time: new Date().getTime(), ...action.payload}  };

      case AUTH_RESET_REQUEST:
      return { ...state, waiting: true };
    case AUTH_RESET_SUCCESS:
      return { ...state, waiting: false };
    case AUTH_RESET_FAILURE:
      return { ...state, waiting: false, error: {time: new Date().getTime(), ...action.payload}  };

      case AUTH_SIGNOUT_SUCCESS:
      return _.omit(state, ['user', 'fbuser','account']);
    case AUTH_SIGNOUT_FAILURE:
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/data/auth/reducer.js